import { getEventList, getProductList } from '@optimizely/opal-app-companion';

// Product types configuration
export const productTypes = getProductList();

// Event types configuration derived from EventSchema
export const eventTypes = getEventList();

// Utility function to get event type label
export const getEventTypeLabel = (value: string) => {
  const eventType = eventTypes.find(type => type.value === value);
  return eventType ? eventType.label : value; // fallback to value if not found
};

export const getEventTypeProduct = (value: string) => {
  const eventType = eventTypes.find(type => type.value === value);
  return eventType
    ? (productTypes.find(product => product.value === eventType.product)?.label ?? null)
    : null;
};
